import { render, staticRenderFns } from "./TreesTen.vue?vue&type=template&id=20f1ca65&scoped=true&"
var script = {}
import style0 from "./TreesTen.vue?vue&type=style&index=0&id=20f1ca65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1ca65",
  null
  
)

export default component.exports